module.exports = __webpack_public_path__ + "static/media/bring-forward.564f8429.svg";